var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
import { FunctionColor } from '@lux/tokens';
export var Wrapper = styled.svg(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    vertical-align: bottom;\n    color: ", ";\n"], ["\n    display: inline-block;\n    width: 16px;\n    height: 16px;\n    vertical-align: bottom;\n    color: ", ";\n"])), FunctionColor.function100);
var templateObject_1;
